import { Headers } from '@egw/components'
import { InvestmentsWrapper } from '@egw/features-investment'
import { useTranslation } from '@egw/i18n'
import { Layout } from '@egw/layouts'
import { type FC } from 'react'

export const InvestmentsPage: FC = () => {
  const { t } = useTranslation()

  return (
    <Layout>
      <Headers title={t('pages.investments.title')} />
      <InvestmentsWrapper />
    </Layout>
  )
}
